export default {
  name: 'marking--taskManagerTask',
};